import React, { useState, useEffect } from 'react';
import { MdInfo } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { ListPropertiesRequest } from '~/store/modules/properties/actions';
import { openProperty } from '~/store/modules/property/actions';
import { Container, CardContainer, Loader, Tooltip, GlobalStyle } from './styles';
import { store } from '~/store';
import history from '~/services/history';
import Search from '~/components/search/index';
import Whatsapp from '~/assets/whatsapp-icon.svg';


import refera from '~/util/refera';

export default function MyProperties() {
  // #region Attributes
  const [properties, setProperties] = useState([]);
  const loading = useSelector(state => state.properties.loading);
  const userType = useSelector(state => state.user.profile.tipoCliente);
  const _state = useSelector(state => state);
  const dispatch = useDispatch();
  const deveMostrarBotao = verificaFranquias();

  // #endregion

  // #region Funcions

  function verificaFranquias() {
    let properties = store.getState().properties?.properties?.properties ?? [];
    let codigosFranquia = properties.map(item => item.codigoFranquia);
    let franquiasMostraBotao = [302, 347, 303, 301, 354];
    return codigosFranquia.some(codigo =>
      franquiasMostraBotao.includes(codigo)
    );
  }


  useEffect(() => {
    const { token } = store.getState().auth;
    dispatch(ListPropertiesRequest(token));

    refera.init(_state)

  }, [dispatch]);

  useEffect(() => {

    var orderByType = 'inquilino';
    if (userType.indexOf('Proprietário') != -1) {
      orderByType = 'proprietario';
    }

    var order = {
      'inquilino': {
        'A': ['Ativo'],
        'B': ['Inativo']
      },
      'proprietario': {
        'A': ['Locado'],
        'B': ['Disponivel', 'Disponível']
      }
    }

    var propertiesOrdered = {}
    var properties = store.getState().properties.properties.properties

    var propertiesOrderedList = []

    if ( typeof properties != 'undefined' ) {
      properties.forEach((property, idx) => {

        var orderItem = "C"

        if ( order[orderByType]['A'].indexOf(property.situacao) != -1 ) {
          orderItem = "A"
        }

        if ( order[orderByType]['B'].indexOf(property.situacao) != -1 ) {
          orderItem = "B"
        }

        const propertyIdentifier =
          property.idContrato || property.idNegocios || idx;

        propertiesOrdered[
          orderItem + '-' + property.referencia + '-' + propertyIdentifier
        ] = property;
      })

      var keys = Object.keys(propertiesOrdered)
      var len = keys.length;
      keys.sort();

      for (var i = 0; i < len; i++) {
        var k = keys[i];
        propertiesOrderedList.push(propertiesOrdered[k])
      }
    }


    setProperties(propertiesOrderedList);
  }, [loading]);

  function GetStatusTextByStatus(status) {
    switch (status) {
      case 'Angariado':
        return 'Seu imóvel está disponível para locação internamente, em breve será disponibilizado no Portal Apolar.';
      case 'Reangariado':
        return 'Seu imóvel está disponível para locação internamente, em breve será disponibilizado no Portal Apolar.';
      case 'Disponível':
      case 'Disponivel':
        return 'Seu imóvel está disponível em nosso Portal Apolar e portais para locação.';
      case 'Chave Emprestada':
        return 'Neste momento, as chaves do seu imóvel foram emprestadas para visita.';
      case 'Reservado':
        return 'Um cliente se interessou pelo seu imóvel, agora irá passar pelo processo de análise cadastral. Vamos torcer!';
      case 'Locado':
        return 'Seu imóvel encontra-se alugado.';
      case 'Em processo de rescisão':
        return 'Seu inquilino formalizou a intenção de desocupar seu imóvel.';
      case 'Desocupado':
        return 'Seu imóvel está desocupado, aguardando sua autorização para nova locação.';
      case 'Suspenso':
        return 'Seu imóvel está suspenso em nosso sistema até sua autorização para nova locação.';
      case 'Em processo de revogação':
        return 'Estamos preparando para retirar o seu imóvel de nosso sistema de administração.';
      case 'Revogado (Baixado)':
        return 'Que pena, seu imóvel não está mais em nossa administração.';
      default:
        return 'Sem informações.';
    }
  }

  function openForm(){
     window.open("https://crm.ops.digital/formulario")
  }

  function openWhatsapp(){
    if(deveMostrarBotao){
      window.open("https://api.whatsapp.com/send?phone=5541991210624")

    }
    else{
      var phone = store.getState().properties.properties.properties[0].telefoneFranquia
      phone = phone.replace("(", "").replace(")", "").replace("-", "").replace(" ", "").replace("  ", "")
       window.open(`https://api.whatsapp.com/send?phone=${phone}`)
    }
  }

  function RedirectToProperties(property) {
    dispatch(
      openProperty({
        contract: property.idContrato,
        reference: property.referencia,
        address: property.endereco,
        status: property.situacao,
        businessId: property.idNegocios,
        email: property.emailFranquia,
        franquia: property.nomeFranquia
      })
    );

    history.push({
      pathname: '/Imovel',
      state: {
        sContractId: property.idContrato,
        sReference: property.referencia,
        sAddress: property.endereco,
        sStatus: property.situacao,
        sBusinessId: property.idNegocios,
        sEmail: property.emailFranquia,
      },
    });
  }

  function handleOpenRepairRequest(property) {

    refera.open(property)
    return false

    window.open("https://admin.refera.com.br/solicitar-manutencao/apolar", '_blank').focus();
    return false

    dispatch(
      openProperty({
        contract: property.idContrato,
        reference: property.referencia,
        address: property.endereco,
        topic: 'Solicitar um reparo',
        franquia: property.nomeFranquia
      })
    );

    history.push({
      pathname: '/SolicitarReparo',
      state: {
        sContractId: property.idContrato,
        sReference: property.referencia,
        sAddress: property.endereco,
        sTopic: 'Solicitar um reparo',
        sFranquia: property.nomeFranquia
      },
    });
  }

  function handleOpenReservationFund(property) {
    dispatch(
      openProperty({
        contract: property.idContrato,
        reference: property.referencia,
        address: property.endereco,
        status: property.situacao,
      })
    );

    history.push({
      pathname: '/FundoDeReserva',
      state: {
        sContractId: property.idContrato,
        sReference: property.referencia,
        sAddress: property.endereco,
        sStatus: property.situacao === 'Ativo',
        sTopic: 'Fundo de reserva',
      },
    });
  }

  function handleToNavigateSecondBillet(property) {
    dispatch(
      openProperty({
        contract: property.idContrato,
        reference: property.referencia,
        address: property.endereco,
        status: property.situacao,
      })
    );

    history.push({
      pathname: '/SegundaViaBoleto',
      state: {
        sContractId: property.idContrato,
        sReference: property.referencia,
        sAddress: property.endereco,
        sStatus: property.situacao === 'Ativo',
      },
    });
  }

  function handleOpenCalendary(property) {
    dispatch(
      openProperty({
        businessId: property.idNegocios,
        reference: property.referencia,
        address: property.endereco,
        topic: 'Calendário de repasse',
      })
    );

    history.push({
      pathname: '/Calendario',
      state: {
        sBusinessId: property.idNegocios,
        sReference: property.referencia,
        sAddress: property.endereco,
        sTopic: 'Calendário de repasse',
      },
    });
  }

  function handleOpenStatement(property) {
    dispatch(
      openProperty({
        businessId: property.idNegocios,
        reference: property.referencia,
        address: property.endereco,
      })
    );

    history.push({
      pathname: '/Extrato',
      state: {
        sBusinessId: property.idNegocios,
        sReference: property.referencia,
        sAddress: property.endereco,
      },
    });
  }

  function handleOpenMyAds(property) {
    dispatch(
      openProperty({
        businessId: property.idNegocios,
        reference: property.referencia,
        address: property.endereco,
        email: property.emailFranquia,
        situacao: property.situacao,
        topic: 'Meus Anúncios',
      })
    );

    history.push({
      pathname: '/MeusAnuncios',
      state: {
        sBusinessId: property.idNegocios,
        sReference: property.referencia,
        sAddress: property.endereco,
        sEmail: property.emailFranquia,
        sTopic: 'Meus Anúncios',
      },
    });
  }

  function handleOpenFinancialSummary(property) {
    dispatch(
      openProperty({
        contract: property.idContrato,
        reference: property.referencia,
        address: property.endereco,
        topic: 'Resumo Financeiro',
      })
    );

    history.push({
      pathname: '/ResumoFinanceiro',
      state: {
        sContractId: property.idContrato,
        sReference: property.referencia,
        sAddress: property.endereco,
        sTopic: 'Resumo Financeiro',
      },
    });
  }
  // #endregion

  return (
    <Container>
      <GlobalStyle />

      <Loader style={{ display: loading ? 'block' : 'none' }} />

      <Search />

      <div style={{width: '100%', display: 'flex', justifyContent: 'space-between'} }>
        <h1 style={{ marginTop: '50px' }}>Meus Imóveis</h1>
        {deveMostrarBotao && (
          <button
            type="button"
            className="button"
            style={{ marginTop: '50px' }}
            onClick={() => openForm()}
          >
            Solicitar ajuda
          </button>
        )}

        <button
          type="button"
          style={{ position: 'fixed', bottom: '25px', right: '25px' }}
          onClick={() => openWhatsapp()}
        >
          <img src={Whatsapp} alt='whatsapp button' style={{width: '60px'}} />
        </button>
      </div>

      {properties && properties.length ? (
        properties.map(p => {
          console.log("Propriedade:", p.situacao)
          console.log("Store", store.getState())

          const isAtivo = p.situacao === 'Ativo';
          return p.idContrato ? (
            <CardContainer
              key={p.idContrato}
              statusColor={isAtivo ? '#66CC00' : '#CC0000'}
            >
              <b className="status">Aluguel {p.situacao}</b>
              <span>{p.endereco}</span>
              <span>Contrato: {p.idContrato}</span>
              <span>Ref.: {p.referencia}</span>

              <div>
                <button
                  type="button"
                  style={{ display: isAtivo ? 'flex' : 'none' }}
                  onClick={() => handleToNavigateSecondBillet(p)}
                >
                  2ª via de boleto
                </button>
                <button
                  type="button"
                  onClick={() => handleOpenReservationFund(p)}
                >
                  Fundo de reserva
                </button>
                {isAtivo ? (
                  <button
                    type="button"
                    onClick={() => handleOpenRepairRequest(p)}
                  >
                    Solicitação de reparos
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={() => handleOpenFinancialSummary(p)}
                  >
                    Resumo Financeiro
                  </button>
                )}

                <button
                  type="button"
                  className="button"
                  onClick={() => RedirectToProperties(p)}
                >
                  + opções
                </button>
              </div>
            </CardContainer>
          ) : (
            <CardContainer key={p.idNegocios}>
              <span className="status">
                <b>Status do imóvel:  </b>{p.situacao} há {p.diasSituacao} dia{p.diasSituacao > 1 ? 's':''}
                <Tooltip>
                  <MdInfo size={20} />
                  <span>{GetStatusTextByStatus(p.situacao)}</span>
                </Tooltip>
              </span>
              <span>{p.endereco}</span>
              <span>N° do negócio: {p.idNegocios}</span>
              <span>Ref.: {p.referencia}</span>

              <div>
                <button type="button" onClick={() => handleOpenStatement(p)}>
                  Extrato
                </button>
                <button type="button" onClick={() => handleOpenCalendary(p)}>
                  Calendário de repasse
                </button>
                <button type="button" onClick={() => handleOpenMyAds(p)}>
                  Meus Anúncios
                </button>
                <button
                  type="button"
                  className="button"
                  onClick={() => RedirectToProperties(p)}
                >
                  + opções
                </button>
              </div>
            </CardContainer>
          );
        })
      ) : (
        <div>Você ainda não possui nenhum imóvel.</div>
      )}
    </Container>
  );
}
